"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const StyledSvg = styled_components_1.styled.svg `
  shape-rendering: ${(props) => props.smooth ? "geometricPrecision" : "crispEdges"};
  fill: ${(props) => props.fill};
`;
/*  Basic React component for a square SVG icon with a 16 × 16 viewBox.
    Children will typically be <path> or other SVG drawing elements.
*/
const Base = ({ size, height, width, smooth = false, fill = "currentcolor", stroke = "none", title, children, viewBox, ...rest }) => (react_1.default.createElement(StyledSvg, { smooth: smooth, fill: fill, stroke: stroke, width: size || width, height: size || height, viewBox: viewBox !== null && viewBox !== void 0 ? viewBox : "0 0 16 16", ...rest },
    react_1.default.createElement(react_1.default.Fragment, null,
        title && react_1.default.createElement("title", null, title),
        children)));
exports.Base = Base;
//# sourceMappingURL=Base.js.map